import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import 'helpers/initFA';
import colabsSlice from 'redux/colabsSlice';
import loginSlice from './redux/loginSlice';
import propsSlice from 'redux/propsSlice';
import realEstateSlice from 'redux/realEstateSlice';
import rolesSlice from 'redux/rolesSlice';
import permisosSlice from 'redux/permisosSlice';
import clientsSlice from 'redux/clientsSlice';
import branchOfficeSlice from 'redux/branchOfficeSlice';
import './index.css';
import axios from 'axios';
import chatSlice from 'redux/chatSlice';
import apiKeysSlice from 'redux/apiKeysSlice';
import searchesSlice from 'redux/searchesSlice';
import notificationsSlice from 'redux/notificationsSlice';
import projectsSlice from 'redux/projectsSlice';
import infoSlice from 'redux/infoSlice';
import matriculadosSlice from 'redux/matriculadosSlice';
import mlSlice from 'redux/mlSlice';

const store = configureStore({
  reducer: {
    props: propsSlice,
    login: loginSlice,
    permisos: permisosSlice,
    roles: rolesSlice,
    colabs: colabsSlice,
    matriculados: matriculadosSlice,
    realEstate: realEstateSlice,
    clients: clientsSlice,
    branchOffice: branchOfficeSlice,
    chat: chatSlice,
    apiKeys: apiKeysSlice,
    searches: searchesSlice,
    notifications: notificationsSlice,
    projects: projectsSlice,
    info: infoSlice,
    ml: mlSlice
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

if (process.env.REACT_APP_LOCAL === 'false') {
  // eslint-disable-next-line no-debugger
  debugger;
}

axios.interceptors.request.use(config => {
  const token = localStorage.getItem('token_A');
  if (token) {
    config.headers['authorization'] = `Bearer ${token}`;
  }
  return config;
});

ReactDOM.render(
  <Provider store={store}>
    <Main>
      <App />
    </Main>
  </Provider>,
  document.getElementById('main')
);
